import { ReactComponent as SendIcon } from "../../../../../Assets/Images/Send.svg";
import { useRef } from "react";

const ChatInput = (props) => {
  const TextAreaRef = useRef(null);

  const handleResetTextAreaHeight = () => {
    if (TextAreaRef) {
      TextAreaRef.current.style.height = "18px";
    }
  };

  const handlePressEnter = (e) => {
    // keyCode: 13 is press 'enter'
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      props.onInputSubmit(e);
      handleResetTextAreaHeight();
    }
  };

  const handleChange = (e) => {
    props.onChangeHandler(e);
    const textAreaLineHeight = 19;

    // set to default element height
    e.target.style.height = textAreaLineHeight + "px";
    const numOfLines = Math.floor(e.target.scrollHeight / textAreaLineHeight);

    // height calculation for multiple row of element.
    // 90 px is for 5 row of text
    if (numOfLines > 1) {
      e.target.style.height = Math.min(e.target.scrollHeight, 90) + "px";
    }
  };

  return (
    <form
      className="chatbot-content-input"
      onSubmit={(e) => {
        props.onInputSubmit(e);
        handleResetTextAreaHeight();
      }}
    >
      <textarea
        ref={TextAreaRef}
        id={props.CustomId ? props.CustomId : "chatbot-input"}
        autoComplete="off"
        placeholder={props.PlaceholderText}
        onChange={(e) => handleChange(e)}
        onKeyDown={handlePressEnter}
      />
      <button
        className="chatbot-content-input-btn"
        id="chatbot-send-btn"
        type={"submit"}
      >
        <SendIcon />
      </button>
    </form>
  );
};

export default ChatInput;
